import React, { ReactElement } from 'react'
import {
  Box,
  Dropdown,
  Flex,
  Icon,
  ResetButton,
  Text,
} from '@mindfulchefuk/design-system'
import { PortionCount } from '@mindfulchefuk/config/portionCountConfig'

import { OnboardingRecipeFilterPortionCountRadioButtons } from './OnboardingPortionCountFilterRadioButtons'
import { TOnboardingRecipeFilterHandlers } from '../OnboardingRecipeFilterHandlers.types'

type TRecipeFilterPortionCount = {
  onChange: TOnboardingRecipeFilterHandlers['portionCount']
  onToggle: () => void
  portionCount: PortionCount
  isOpen: boolean
}

export const OnboardingChooseRecipesPortionCountFilter = ({
  portionCount,
  onChange,
  onToggle,
  isOpen,
}: TRecipeFilterPortionCount): ReactElement => {
  let label = ''
  switch (portionCount) {
    case 1:
      label = '1 person'
      break
    case 4:
      label = 'Family'
      break
    default:
      label = `${portionCount} people`
  }

  return (
    <Box position="relative" id="portion-count-filter">
      <ResetButton
        display="block"
        data-testid="recipe-filter-portion-count"
        onClick={() => {
          onToggle()
        }}
      >
        <Flex color="aubergine">
          <Icon type="people" flexShrink={0} mr={8} />
          <Text
            variant="body-sm-500-caps"
            as="span"
            color="aubergine"
            data-testid="portion-count-label"
          >
            {label}
          </Text>
          <Icon ml={10} type={isOpen ? 'chevron-up' : 'chevron-down'} />
        </Flex>
      </ResetButton>
      <Dropdown
        isOpen={isOpen}
        onToggle={onToggle}
        width="215px"
        alignment={{ base: 'left', sm: 'right', md: 'left' }}
      >
        <Text variant="body-sm-500-caps" mb={16} color="aubergine">
          How many people are you cooking for?
        </Text>
        <OnboardingRecipeFilterPortionCountRadioButtons
          onChange={onChange}
          portionCount={portionCount}
        />
        <Text variant="body-sm" color="aubergine-400" mt={4}>
          4 adults or 2 adults and 2-3 children
        </Text>
      </Dropdown>
    </Box>
  )
}
